import { useMutation } from "@tanstack/react-query";

import httpClient from "@/config/axios";
import type { RosterCreateConfigPayload } from "../service/rosterCreateConfigPayload";

export type SyncRosterCreateConfigParams = {
  configPayload: RosterCreateConfigPayload;
  isAdmin: boolean;
  selectedGroupId?: string | null;
};

type SyncRosterCreateConfigResult = {
  configId: number | null;
  version: number | null;
  configName: string | null;
  configMemo: string | null;
};

export default function useSyncRosterCreateConfigMutation() {
  return useMutation<
    SyncRosterCreateConfigResult,
    Error,
    SyncRosterCreateConfigParams
  >({
    mutationFn: async ({
      configPayload,
      isAdmin,
      selectedGroupId,
    }) => {
      const savedConfig = await httpClient.post<{
        config_id?: number | null;
        version?: number | null;
        config_name?: string | null;
        config_memo?: string | null;
      }>(
        "/roster/config/save",
        configPayload,
        {
          params:
            isAdmin && selectedGroupId
              ? { group_id: selectedGroupId }
              : undefined,
        }
      );

      return {
        configId: savedConfig?.config_id ?? configPayload.config_id ?? null,
        version: savedConfig?.version ?? null,
        configName: savedConfig?.config_name ?? configPayload.config_name ?? null,
        configMemo: savedConfig?.config_memo ?? configPayload.config_memo ?? null,
      };
    },
  });
}
